'use client';

import { useIdleMount } from '@repo/web-chrome/lib/use-idle-mount';
import { useEffect } from 'react';

// The WebMCP descriptor (for agentic browsers) is not needed at first paint, and its
// transport + MCP SDK + JSON-schema deps are heavy (~hundreds of KB). Defer to idle AND
// lazy-import them inside the effect so none of that closure lands in the LCP-critical
// initial bundle (it was ~the whole @mcp-b/transports + zod-to-json-schema + ajv chunk on
// every page). Discovery still works without JS via the `<meta name="mcp">` tag and
// /.well-known/mcp.json; only the runtime tab-transport connection defers a beat.
export function WebMcpProvider(): null {
  const ready = useIdleMount();

  useEffect(() => {
    if (!ready) {
      return;
    }
    let cancelled = false;
    let cleanup: (() => void) | undefined;
    void Promise.all([import('@mcp-b/transports'), import('@repo/web-chrome/lib/webmcp')]).then(
      ([{ TabServerTransport }, { createMcpServer }]) => {
        if (cancelled) {
          return;
        }
        const server = createMcpServer();
        const transport = new TabServerTransport({ allowedOrigins: ['*'] });
        server.connect(transport).catch(() => {});
        cleanup = (): void => {
          server.close().catch(() => {});
        };
      },
    );
    return (): void => {
      cancelled = true;
      cleanup?.();
    };
  }, [ready]);

  return null;
}
